export const FETCH_FIREBASE_EXPERIMENTS_SUCCESS = 'myaxa/abTest/FETCH_FIREBASE_EXPERIMENTS_SUCCESS';
export const FETCH_OPTIMIZE_EXPERIMENTS_SUCCESS = 'myaxa/abTest/FETCH_OPTIMIZE_EXPERIMENTS_SUCCESS';

export const initialState = {
  firebaseExperiments: {},
  optimizeExperiments: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_FIREBASE_EXPERIMENTS_SUCCESS: {
      return { ...state, firebaseExperiments: action.payload.firebaseExperiments };
    }
    case FETCH_OPTIMIZE_EXPERIMENTS_SUCCESS: {
      return { ...state, optimizeExperiments: action.payload.optimizeExperiments };
    }
    default:
      return state;
  }
}
